export default __webpack_public_path__ + "static/media/mobile_framing.4a98e9cf.png";